(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-section"] && !Shopify.designMode) return;
  try {
    
  $('.i-imagewrap').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  centerMode: true,
  arrows: false,
  dots: false,
  autoplaySpeed: 0,
  speed: 10000,
  centerPadding: '100px',
  infinite: true,
  autoplay: true,
  cssEase: 'linear',
  responsive: [
     {
        breakpoint: 1500,
        settings: {
        slidesToShow: 6,
        slidesToScroll: 2
       }
    },
    {
    breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
       }
    },
    {
    breakpoint: 600,
      settings: {
          slidesToShow: 3,
          slidesToScroll: 2
      }
    },
    {
    breakpoint: 480,
      settings: {
          slidesToShow: 2,
          slidesToScroll: 1
      }
      
    }
  ]
  });

  // Make logos clickable on the moving carousel (a real tap opens the link, a drag still scrolls)
  var pcgStart = null;
  $('.i-imagewrap').on('mousedown touchstart', '.img a', function (e) {
    var p = e.originalEvent.touches ? e.originalEvent.touches[0] : e;
    pcgStart = { x: p.pageX, y: p.pageY };
  });
  $('.i-imagewrap').on('mouseup touchend', '.img a', function (e) {
    if (!pcgStart) return;
    var p = e.originalEvent.changedTouches ? e.originalEvent.changedTouches[0] : e;
    var moved = Math.abs(p.pageX - pcgStart.x) > 10 || Math.abs(p.pageY - pcgStart.y) > 10;
    pcgStart = null;
    if (!moved) {
      var href = $(this).attr('href');
      if (href) { window.open(href, '_blank', 'noopener'); }
    }
  });
  $('.i-imagewrap').on('click', '.img a', function (e) { e.preventDefault(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;
      const type = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = type === 'always' || type === 'reduce-logo-size';
      this.shrinks = type === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.shrinks) {
        // PCG: shrink 68 -> 56px once the bar is actually stuck, i.e. the ticker row above it has
        // scrolled away. Reads the bar's own position, so it works whatever sits above or below it.
        const stuck = scrollTop > 4 && this.header.getBoundingClientRect().top <= 0.5;
        if (stuck !== this.header.classList.contains('scrolled-past-header')) {
          this.header.classList.toggle('scrolled-past-header', stuck);
        }
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.querySelectorAll('pcg-menu').forEach((menu) => menu.close && menu.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
